import { useQuery } from '@tanstack/react-query';
import { getHub } from '../api/hub';

/**
 * Hämtar aktuell user:s primära workspace-id. Vi använder /api/hub-endpointen
 * eftersom den redan auto-resolvar workspaceId från sessionen. Resultatet
 * cache:as via React Query — samma key som Hub-page använder, så vi
 * undviker dubbla nätverkskall.
 */
export function useWorkspaceId(): string | undefined {
  // Använd samma queryKey som Hub.tsx så cachen delas — vi får data direkt
  // om Hub:n hunnit ladda först.
  const q = useQuery({
    queryKey: ['hub'],
    queryFn: () => getHub(),
    staleTime: 5 * 60 * 1000,
  });
  return q.data?.workspaceId;
}
